var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgArrowIcon(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 64 64",
    "aria-labelledby": "title",
    "aria-describedby": "desc"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    xmlns: "http://www.w3.org/2000/svg",
    "data-name": "layer1",
    fill: "#202020",
    stroke: "#202020",
    strokeMiterlimit: 10,
    strokeWidth: 2,
    d: "M6 2l52 30L6 62V2z",
    strokeLinejoin: "round",
    strokeLinecap: "round"
  })));
}
export default __webpack_public_path__ + "static/media/arrowIcon.88e44f15.svg";
export { SvgArrowIcon as ReactComponent };